import { useRequest } from 'ahooks';
import { Button } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import { oSSController } from '../api';
import { useCompany } from '../hooks/company';

const formatDuration = (seconds?: number) => {
  if (!seconds || seconds <= 0) {
    return '';
  }
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m > 0) {
    return `${m}分${s}秒`;
  }
  return `${s}秒`;
};

/**
 * 通话录音播放器：初始展示播放按钮，点击后才请求 OSS 临时 URL 并播放
 */
export default ({
  ossKey,
  duration,
}: {
  ossKey: string;
  duration?: number;
}) => {
  const { id: companyId } = useCompany();

  const {
    data: url,
    loading,
    run,
  } = useRequest(
    () => oSSController.getOSSUrl(companyId, ossKey, undefined, undefined),
    {
      manual: true,
    },
  );

  if (url) {
    return (
      <audio
        controls
        autoPlay
        src={url}
        style={{ maxWidth: '100%', height: '32px' }}
        preload="metadata"
        // 通话录音仅允许在线播放：隐藏浏览器下载按钮并禁用右键菜单（另存为）
        controlsList="nodownload"
        onContextMenu={(e) => e.preventDefault()}
      >
        您的浏览器不支持音频播放
      </audio>
    );
  }

  const durationText = formatDuration(duration);

  return (
    <Button
      type="link"
      size="small"
      style={{ padding: 0, fontWeight: 500 }}
      icon={<PlayCircleOutlined />}
      loading={loading}
      onClick={run}
    >
      播放录音{durationText ? `（${durationText}）` : ''}
    </Button>
  );
};
